const getCurrentDateString = () => new Date().toISOString()
export default getCurrentDateString
